import axios, { AxiosRequestConfig } from 'axios'

export enum HttpMethod {
  GET = 'get',
  POST = 'post',
}

class NetworkError {
  status: number

  message: string

  constructor(error: any) {
    if (error.response) {
      this.status = error.response.status
      this.message = error.response.message
    } else if (error.request) {
      this.status = 444
      this.message = 'Empty Response'
    } else {
      this.status = 417
      this.message = 'Invalid Request'
    }
  }
}

export interface Networking {
  readonly baseUrl: string
  readonly get: <T = any>(path: string, config?:any) => Promise<T>
  readonly post: <T = any>(path: string, body: any, config?:any) => Promise<T>
}

interface RequestConfig extends AxiosRequestConfig {
}

const defaultConfig: RequestConfig = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  params: {
    format: 'json',
  },
}

class Network implements Networking {
  baseUrl: string

  get: <T = any>(path: string, config?: RequestConfig) => Promise<T>

  post: <T = any>(path: string, body?: any, config?: RequestConfig) => Promise<T>

  private readonly request: <T = any>(config: RequestConfig) => Promise<T>

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl

    this.get = <T = any>(path: string, config?: RequestConfig) => {
      return this.request<T>({
        ...config,
        url: path,
        method: HttpMethod.GET,
      })
    }

    this.post = <T = any>(path: string, body?: any, config?: RequestConfig) => {
      return this.request<T>({
        ...config,
        url: path,
        method: HttpMethod.POST,
        data: body,
      })
    }

    this.request = <T = any>(config: RequestConfig): Promise<T> => {
      return new Promise<T>((resolve, reject: (reason: NetworkError) => void) => {
        const requestConfig: RequestConfig = {
          baseURL: this.baseUrl,
          ...defaultConfig,
          ...config,
        }
        return axios.request<T>(requestConfig)
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(new NetworkError(error))
          })
      })
    }
  }
}

export default Network
